import { Button } from "@progress/kendo-react-buttons";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Badge } from "@progress/kendo-react-indicators";
import { formatCurrency, formatDate } from "../../utils/formatters";
import { getOptionLabel } from "../../utils/i18n";

const priorityTone = {
  Low: "success",
  Medium: "info",
  High: "warning",
  Critical: "error"
};

export default function ExpenseTable({ currencyCode, expenses, locale, onDelete, onEdit, t = {} }) {
  const optionLabel = (group, value, fallback = value) => getOptionLabel(locale, group, value, fallback);

  return (
    <div className="expense-table-desktop">
      <Grid data={expenses} sortable resizable>
        <GridColumn field="title" title={t.name || "Name"} width="220px" />
        <GridColumn
          field="amountConverted"
          title={(t.amountColumn || ((currency) => `Amount (${currency})`))(currencyCode)}
          width="150px"
          cell={(props) => (
            <td className="amount-cell">
              {formatCurrency(props.dataItem.amountConverted, currencyCode, locale?.localeCode)}
            </td>
          )}
        />
        <GridColumn
          field="category"
          title={t.category || "Category"}
          width="170px"
          cell={(props) => (
            <td>
              <Badge themeColor="primary" shape="rounded">
                {optionLabel("categories", props.dataItem.category)}
              </Badge>
            </td>
          )}
        />
        <GridColumn
          field="date"
          title={t.date || "Date"}
          width="140px"
          cell={(props) => <td>{formatDate(props.dataItem.date, locale?.localeCode)}</td>}
        />
        <GridColumn
          field="priority"
          title={t.priority || "Priority"}
          width="120px"
          cell={(props) => (
            <td>
              <Badge themeColor={priorityTone[props.dataItem.priority] || "info"} shape="rounded">
                {optionLabel("priorities", props.dataItem.priority)}
              </Badge>
            </td>
          )}
        />
        <GridColumn
          field="frequency"
          title={t.repeat || "Repeat"}
          width="120px"
          cell={(props) => (
            <td>
              {props.dataItem.parentRecurringId
                ? locale?.common?.generated || "Generated"
                : optionLabel("frequencies", props.dataItem.frequency)}
            </td>
          )}
        />
        <GridColumn
          field="receiptName"
          title={t.receipt || "Receipt"}
          width="120px"
          cell={(props) => (
            <td>
              {props.dataItem.receiptDataUrl ? (
                <Button
                  fillMode="flat"
                  icon="eye"
                  onClick={() => window.open(props.dataItem.receiptDataUrl, "_blank")}
                >
                  {locale?.common?.view || "View"}
                </Button>
              ) : (
                <span className="muted">{locale?.common?.none || "None"}</span>
              )}
            </td>
          )}
        />
        <GridColumn
          title={t.actions || "Actions"}
          width="170px"
          cell={(props) => (
            <td>
              <div className="row-actions">
                <Button fillMode="flat" icon="edit" onClick={() => onEdit(props.dataItem)}>
                  {locale?.common?.edit || "Edit"}
                </Button>
                <Button fillMode="flat" themeColor="error" icon="delete" onClick={() => onDelete(props.dataItem.id)}>
                  {locale?.common?.delete || "Delete"}
                </Button>
              </div>
            </td>
          )}
        />
      </Grid>
    </div>
  );
}
